import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { TabContent } from "../../../../common/components/dotLegalTabs/DotLegalTabs.types";
import { useTranslation } from "../../../../localization/useTranslation";
import { FrameworkTemplateCategoryViewModel } from "../FrameworkTemplateCategories.types";
import useFrameworkTemplateCategoryDialogHooks from "./FrameworkTemplateCategoryDialog.hooks";
import DotLegalTabs from "../../../../common/components/dotLegalTabs/DotLegalTabs";

export interface IFrameworkTemplateCategoryDialogProps {
    frameworkTemplateId: string;
    model?: FrameworkTemplateCategoryViewModel;
    onDialogClose: () => void;
}

function FrameworkTemplateCategoryDialog(props: IFrameworkTemplateCategoryDialogProps) {
    const { translateString } = useTranslation();
    const { templateModel, selectedTabIndex, setSelectedTabIndex, isEdit, modelUpdater, save } = useFrameworkTemplateCategoryDialogHooks(props);

    let tabContents: TabContent[] = ["en", "da"].map((lang, i) => {
        let langModel = templateModel.languages.find((l) => l.twoLetterIsoLanguage === lang)!;
        return {
            label: lang,
            index: i,
            content: (
                <Box>
                    <DotLegalTextField
                        label={translateString("name")}
                        onChange={(value) => modelUpdater.onNameChange(value, lang)}
                        value={langModel.name}
                        debounce={false}
                    />
                    <DotLegalTextField
                        label={translateString("description")}
                        onChange={(value) => modelUpdater.onDescriptionChange(value, lang)}
                        value={langModel.description ?? ""}
                        debounce={false}
                    />
                </Box>
            ),
        };
    });
    return (
        <DotLegalDialog
            header={`${isEdit ? translateString("edit") : translateString("create")} ${translateString("category")}`}
            buttonOkText={isEdit ? translateString("save") : translateString("create")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={() => save()}
            size="sm"
        >
            <>
                <DotLegalTabs
                    tabStyle={"secondary"}
                    selectedTab={selectedTabIndex}
                    setSelectedTab={setSelectedTabIndex}
                    content={tabContents}
                    fullWidth
                    border
                />
                <DotLegalTextField
                    label={translateString("id")}
                    onChange={modelUpdater.onCustomIdChange}
                    value={templateModel.customId ?? ""}
                    debounce={false}
                />
            </>
        </DotLegalDialog>
    );
}

export default FrameworkTemplateCategoryDialog;
